import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    this.load.audio('bgaudio', 'assets/audio/bgm/bgm1.mp3');
    this.load.audio('correctAnswer', 'assets/audio/correctAnswer.mp3');
    this.load.audio('wrongAnswer', 'assets/audio/wrongAnswer.wav');
    this.load.audio('waterCan', 'assets/audio/waterCan.wav');
    this.load.audio('watering', 'assets/audio/watering.wav');
    this.load.audio('sunShining', 'assets/audio/sunShining.mp3');
    this.load.audio('flowerBlossoming', 'assets/audio/flowerBlossoming.wav');
    this.load.audio('hover', 'assets/audio/hover.wav');
    this.load.audio('hintAlert', 'assets/audio/hintAlert.mp3');
    this.load.audio('yay', 'assets/audio/yay.wav');
    this.load.audio('ta1', 'assets/audio/vo/ta1.mp3');
    this.load.audio('ta2', 'assets/audio/vo/ta2.mp3');
    this.load.audio('ta3', 'assets/audio/vo/ta3.mp3');
    this.load.audio('ta4', 'assets/audio/vo/ta4.mp3');

    this.load.image('startSceneBG', 'assets/StartSceneAssets/StartSceneBG.png');
    this.load.image('playButton', 'assets/StartSceneAssets/playButton.png');
    this.load.image('hover_playButton', 'assets/StartSceneAssets/hover_playButton.png');
    this.load.atlas(
      'playSwayAnim',
      'assets/CommonAssets/animations/playSwayAnim.png',
      'assets/CommonAssets/animations/playSwayAnim.json',
    );
    this.load.atlas(
      'wateringCanAnim',
      'assets/CommonAssets/animations/wateringCanAnim.png',
      'assets/CommonAssets/animations/wateringCanAnim.json',
    );
    this.load.image('startSceneText', 'assets/StartSceneAssets/startSceneText.png');

    this.load.image('hitBoxTut', 'assets/TutorialSceneAssets/hitBoxTut.png');

    this.load.atlas(
      'flowering1Anim',
      'assets/CommonAssets/animations/flowering1Anim.png',
      'assets/CommonAssets/animations/flowering1Anim.json',
    );
    this.load.atlas(
      'flowering2Anim',
      'assets/CommonAssets/animations/flower2Anim.png',
      'assets/CommonAssets/animations/flower2Anim.json',
    );
    this.load.atlas(
      'flowering3Anim',
      'assets/CommonAssets/animations/flower3Anim.png',
      'assets/CommonAssets/animations/flower3Anim.json',
    );
    this.load.atlas(
      'flowering4Anim',
      'assets/CommonAssets/animations/flower4Anim.png',
      'assets/CommonAssets/animations/flower4Anim.json',
    );
    this.load.atlas(
      'flowering5Anim',
      'assets/CommonAssets/animations/flower5Anim.png',
      'assets/CommonAssets/animations/flower5Anim.json',
    );
    this.load.atlas(
      'flowering6Anim',
      'assets/CommonAssets/animations/flower6Anim.png',
      'assets/CommonAssets/animations/flower6Anim.json',
    );

    this.load.multiatlas(
      'sunAnim',
      'assets/CommonAssets/animations/sunAnim/sunAnim.json',
      'assets/CommonAssets/animations/sunAnim',
    );

    this.load.atlas(
      'wrongPlacardAnim',
      'assets/CommonAssets/animations/wrongPlacardAnim.png',
      'assets/CommonAssets/animations/wrongPlacardAnim.json',
    );

    this.load.image('hand', 'assets/TutorialSceneAssets/hand.png');
    this.load.image('grass', 'assets/CommonAssets/grass.png');

    this.load.image('addWaterButton', 'assets/CommonAssets/addWaterButton.png');
    this.load.image('hover_addWaterButton', 'assets/CommonAssets/hover_addWaterButton.png');
    this.load.image(
      'disable_addWaterButton',
      'assets/CommonAssets/disable_addWaterButton.png',
    );

    this.load.image('can', 'assets/CommonAssets/can.png');
    this.load.image('whiteBoxQ5', 'assets/CommonAssets/whiteBoxQ5.png');

    this.load.image('progressBar', 'assets/CommonAssets/progressBar.png');
    this.load.image('correctGreen', 'assets/CommonAssets/correctGreen.png');

    this.load.image('qnBoard', 'assets/CommonAssets/qnBoard.png');
    this.load.image('ansBoard', 'assets/CommonAssets/ansBoard.png');
    this.load.image('line', 'assets/CommonAssets/line.png');
    this.load.image('redLine', 'assets/CommonAssets/redLine.png');
    this.load.image('inputWindow', 'assets/CommonAssets/inputWindow.png');
    this.load.image('overlay', 'assets/CommonAssets/Overlay.png');
    this.load.image('deselectText', 'assets/CommonAssets/deselectText.png');

    this.load.image('hintIcon', 'assets/CommonAssets/hint/Hint.png');
    this.load.image('hint_1', 'assets/CommonAssets/hint/hint-1hdpi.png');
    this.load.image('hint_2', 'assets/CommonAssets/hint/hint-2hdpi.png');
    this.load.image('closeHint', 'assets/CommonAssets/hint/closeHintIconhdpi.png');
    this.load.atlas(
      'hintFinalAnim',
      'assets/CommonAssets/hint/hintFinalAnim.png',
      'assets/CommonAssets/hint/hintFinalAnim.json',
    );

    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
  }

  update() {}
}
